import React from "react";

function Title({ children }) {
  return (
    <div className="my-10 px-4" dir="rtl">
      <h1 className=" text-gray-700 text-right text-xl mb-2">{children}</h1>
      <div
        className="h-1 w-10/12 bg-gray-700 rounded-full"
        style={{ height: "0.1px" }}
      />
    </div>
  );
}

export default Title;
